var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[(_vm.loading)?_c('loading'):_c('div',{staticClass:"page-content"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('header-menu'),_c('navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }